import { render } from "./PortraitsView.vue?vue&type=template&id=719f4200&scoped=true"
import script from "./PortraitsView.vue?vue&type=script&lang=js"
export * from "./PortraitsView.vue?vue&type=script&lang=js"

import "./PortraitsView.vue?vue&type=style&index=0&id=719f4200&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-719f4200"

export default script